import DashboardContainer from '../../containers/admin/DashboardContainer';

export default function DashboardPage() {
    return (
        <DashboardContainer />
    );
}
